import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const METHODS = [
  ["efectivo", "Efectivo"],
  ["tarjeta", "Tarjeta / TPV"],
  ["transferencia", "Transferencia"],
  ["bizum", "Bizum"],
  ["otro", "Otro"],
];

export function MarkPaidDialog({ serviceId, onDone }) {
  const [open, setOpen] = useState(false);
  const [method, setMethod] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/services/${serviceId}/mark-paid`, { method, note });
      toast.success("Servicio marcado como pagado");
      setOpen(false);
      onDone(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="mark-paid-btn" className="ml-2 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest border border-black hover:bg-black hover:text-white transition-colors">
        Marcar pagado
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none border-2 border-black max-w-sm" data-testid="mark-paid-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">¿Cómo ha pagado el cliente?</DialogTitle>
            <DialogDescription>Quedará registrado en el historial del servicio.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-2">
            {METHODS.map(([k, l]) => (
              <button key={k} onClick={() => setMethod(k)} data-testid={`mark-paid-method-${k}`}
                style={method === k ? { color: "#fff" } : undefined}
                className={`h-11 border-2 text-sm font-semibold transition-colors ${method === k ? "bg-black text-white border-black" : "border-zinc-300 hover:border-black"}`}>
                {l}
              </button>
            ))}
          </div>
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota (opcional)" className="rounded-none border-black" data-testid="mark-paid-note" />
          <Button disabled={!method || busy} onClick={submit} className="rounded-none h-11 bg-black hover:bg-emerald-700" data-testid="mark-paid-confirm">
            {busy && <Loader2 className="animate-spin mr-2" size={16} />} Confirmar pago
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
